import axios from '@_system/axios/axios.js'
export default {
	path: '/preoutorder',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	wlnlistTrades(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/wlnlistTrades', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	wlngetOrders(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/wlngetOrders', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	wlnqueryStorageDetail(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/wlnqueryStorageDetail', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	submitsplitorder(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/submitsplitorder', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	gettradetask(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/gettradetask', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	updatefromlist(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updatefromlist/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	
	
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/preoutorder.preoutorder', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
